if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          tabButtons: this.querySelectorAll('.media-tab-btn'),
          dotContainer: this.querySelector('.mobile-slider-dots')
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        // --- MOBILE INIT ---
        if(this.elements.tabButtons && this.elements.tabButtons.length > 0) {
            this.elements.tabButtons.forEach(btn => {
                btn.addEventListener('click', this.onTabClick.bind(this));
            });
            // Force "Images" tab on mobile load
            if (!this.mql.matches) {
               setTimeout(() => this.filterSlides('image'), 50);
            }
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        
        // --- FIXED DOTS LISTENER ---
        // Attach the scroll listener specifically to the scrollable slider element
        if (this.elements.viewer.slider) {
             this.elements.viewer.slider.addEventListener('scroll', this.updateDots.bind(this));
        }

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onTabClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const filterType = button.dataset.tabType;
        
        this.elements.tabButtons.forEach(btn => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        
        this.filterSlides(filterType);
      }

      filterSlides(filterType) {
        const slides = this.elements.viewer.querySelectorAll('.product__media-item');
        let visibleCount = 0;
        let firstVisibleSlide = null;

        slides.forEach(slide => {
            // STRICT FILTERING: Ignore Desktop slides completely
            if (slide.classList.contains('desktop-only-scope')) return;

            const mediaType = slide.dataset.mediaType;
            let shouldShow = false;

            if (filterType === 'image') {
                if(mediaType === 'image') shouldShow = true;
            } else if (filterType === 'video') {
                if(mediaType === 'video' || mediaType === 'external_video') shouldShow = true;
            } else if (filterType === 'model') {
                if(mediaType === 'model') shouldShow = true;
            }

            if (shouldShow) {
                slide.style.display = 'flex'; 
                slide.classList.remove('hidden'); 
                visibleCount++;
                if(!firstVisibleSlide) firstVisibleSlide = slide;
            } else {
                slide.style.display = 'none';
                slide.classList.remove('is-active');
            }
        });

        // Update Dots
        this.refreshDots(visibleCount);

        // Reset Slider to 0
        if (firstVisibleSlide) {
            slides.forEach(s => s.classList.remove('is-active'));
            firstVisibleSlide.classList.add('is-active');
            
            if (this.elements.viewer.slider) {
                this.elements.viewer.slider.scrollLeft = 0;
                if(typeof this.elements.viewer.resetPages === 'function') this.elements.viewer.resetPages();
                if(typeof this.elements.viewer.updateArrowNamespace === 'function') this.elements.viewer.updateArrowNamespace();
            }
        }
        
        // Force Resize
        window.dispatchEvent(new Event('resize'));
        // Initial dot update
        this.updateDots();
      }

      refreshDots(count) {
          if(!this.elements.dotContainer) return;
          this.elements.dotContainer.innerHTML = '';
          for(let i=0; i < count; i++) {
              const dot = document.createElement('button');
              dot.className = 'mobile-dot';
              if(i === 0) dot.classList.add('is-active');
              // Add click event to dots to scroll to that slide
              dot.addEventListener('click', () => {
                 if (this.elements.viewer.slider) {
                    const slideWidth = this.elements.viewer.slider.clientWidth;
                    this.elements.viewer.slider.scrollTo({ left: i * slideWidth, behavior: 'smooth' });
                 }
              });
              this.elements.dotContainer.appendChild(dot);
          }
      }

      updateDots() {
          // Throttle slightly
          if (this.ticking) return;
          this.ticking = true;
          
          window.requestAnimationFrame(() => {
              const dots = this.elements.dotContainer ? this.elements.dotContainer.querySelectorAll('.mobile-dot') : [];
              if (!dots.length || !this.elements.viewer.slider) {
                  this.ticking = false;
                  return;
              }

              const scrollLeft = this.elements.viewer.slider.scrollLeft;
              const slideWidth = this.elements.viewer.slider.clientWidth;
              const index = Math.round(scrollLeft / slideWidth);

              dots.forEach((dot, i) => {
                  if (i === index) dot.classList.add('is-active');
                  else dot.classList.remove('is-active');
              });
              
              this.ticking = false;
          });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}